export default {
  transactions: (state) => state.transactions
}



// WEBPACK FOOTER //
// ./src/store/modules/billing/getters.js